<template>
  <div class="wrap">
      <car-headerbar title="呱呱问卷" :isCustomLeft="isCustomLeft"/>
      <!-- <header-back title="呱呱问卷" @back="back"></header-back> -->
        <form action="/" class="form-search">
          <me-search
              ref="search"
              v-model="condition"
              show-action
              :placeholder="placeholder"
              @search="onSearch"
              @focus="onFocus"
              @input="onInput"
              @clear="onClear"
              @cancel="cancelSearch">
            <template #action v-if="createBtnShow">
              <me-button type="primary" size="small"  class="create-btn" icon="plus" @click.prevent="onCreate">创建</me-button>
            </template>
          </me-search>
        </form>
        <mescroll-vue :class="{guagua: !isGuaGua}" ref="mescroll" :up="mescrollUp" @init="mescrollInit">
        <!-- <me-pull-refresh v-model="refreshing" @refresh="onRefresh"> -->
          <me-list
            v-if="list.length > 0"
            v-model="pullLoading"
            :finished="finished"
            :offset="10"
            finished-text=""
            @load="getList"
          >
            <div class="card" v-for="(item) in list" :key="item.pageId" @click="openSheet(item)" >
              <div class="main">
                  <div class="title">{{item.pageName}}</div>
                  <div class="content">
                    <p :class="{ Published : item.pageStatus=='Published' ,Unpublished : item.pageStatus=='Unpublished' }">
                      {{item.pageStatusName}}
                    </p>
                    <p v-if="isSuperAdmin">{{item.createdByName}}</p>
                    <p v-if="isSuperAdmin" style="margin-top: .16rem;">{{item.lastDeployTime}}</p>
                  </div>

              </div>
              <div class="right">
                  <div class="title">
                  <span :class="{ Published : item.pageStatus=='Published' ,Unpublished : item.pageStatus=='Unpublished' }">{{item.answerCount}}</span>
                    </div>
                  <div class="content">答题数量</div>
              </div>
            </div>
          </me-list>
          <div class="empty-content" v-else>

            <template v-if="!isEmpty">
              <div v-if="isFirst">
                <img src="@assets/images/empty_question.png" alt="" />
                <p>您还没有创建问卷呦！</p>
                <p class="sub">点击【+创建】，创建您的第一份问卷吧</p>
              </div>
              <!-- <div v-else>
                <p>数据加载中</p>
              </div> -->
            </template>

            <div v-else>
              <img src="@assets/images/empty_question.png" alt="" />
              <p>很抱歉，没有找到相关问卷！</p>
            </div>
          </div>
        <!-- </me-pull-refresh> -->
      </mescroll-vue>
      <card
        :tid = "tid"
        :list ="list"
        :sheetShow ="sheetShow"
        :curItem ="curItem"
        @reflesh ="onRefresh"
        @delete = "deleteItem"
        @cancel ="onCancel"
      />
      <TemplateCard
        :tid = "tid"
        :sheetShow="createSheetShow"
        @cancel ="createSheetShow = false"></TemplateCard>
    <!-- <me-loading size="36px" vertical v-show="isLoading" class="me-pullLoading">加载中...</me-loading> -->
  </div>
</template>
<script>
import { Toast } from '@guazi-fe/melon'
import { Questionnaire } from '@/network'
import { mixin } from '@/mixins'
// import { off as offStatus } from '@/util/status-util'
import { addClass2, removeClass2 } from '@/util/status-util'
import Card from '../compontents/card.vue'
import TemplateCard from '../compontents/create.vue'
import MescrollVue from 'mescroll.js/mescroll.vue'
import browser from '@/util/browser'
import NativeApi from 'native-api'

export default {
    data() {
        return {
            isLoading: false,
            condition: '',
            isEmpty: false,
            createBtnShow: true,
            createSheetShow: false,
            sheetShow: false,
            list: [],
            pullLoading: false,
            finished: false,
            refreshing: false,
            pageNum: 1,
            pageSize: 20,
            curItem: {},
            isFirst: false,
            mescroll: null,
            // mescrollDown: {},
            mescrollUp: {
              callback: this.upCallback,
              empty: {
                tip: '暂无相关数据~'
              },
              htmlNodata: '<p class="upwarp-nodata"> 没有更多了~ </p>'
            },
            isGuaGua: true,
            isCustomLeft: false,
        }
    },
    components: {
        Card,
        MescrollVue,
        TemplateCard,
    },
    mixins: [mixin],
    created() {
        // this.getList()
        this.$store.commit('removeRangeList')
        addClass2('body', 'loading')
        const { guaguaApp } = browser
        this.isGuaGua = guaguaApp
        if (guaguaApp) {
            this.isCustomLeft = guaguaApp
        }
    },
    computed: {
        placeholder() {
            return this.isSuperAdmin ? '搜索问卷、创建人姓名/邮箱前缀' : '搜索问卷'
        },
    },
    mounted() {
      if (/Android/gi.test(navigator.userAgent)) {
          // 如果是安卓用户，则需要做处理
          NativeApi.register('back', (data, responseCallback) => {
              responseCallback('{preventDefault: true}') // 阻止默认返回事件
              NativeApi.invoke('closeCurrentWebView', null, () => {})
          })
      } else {
          NativeApi.register('back', (data, responseCallback) => {
              responseCallback({ 'preventDefault': true }) // 阻止默认返回事件
              NativeApi.invoke('closeCurrentWebView', null, () => {})
          })
      }
    },
    methods: {
        back() {
          this.$router.replace({
            name: 'index'
          })
        },
        mescrollInit (mescroll) {
          this.mescroll = mescroll // 如果this.mescroll对象没有使用到,则mescrollInit可以不用配置
        },
        upCallback(page, mescroll) {
          this.pageNum = page.num
          this.getList(mescroll)
        },
        getList(mescroll) {
            // addClass2('body', 'loading')
            removeClass2('body', 'loading')
            // 重置
            this.isEmpty = false
            if (!this.condition) {
                this.createBtnShow = true
            }
            if (this.refreshing) {
                this.list = []
                this.refreshing = false
            }
            const data = {
                tid: this.tid,
                condition: this.condition,
                pageSize: this.pageSize,
                pageNum: this.pageNum,
            }
            Questionnaire.getQuestionList(data).then((res) => {
                // offStatus('loading')
                // removeClass2('body', 'loading')
                this.pullLoading = false
                this.finished = true
                const { code, data } = res.data
                if (code == 'S00000') {
                    this.isFirst = false
                    if (data.list.length && data.list.length) {
                        this.list = this.pageNum === 1 ? [...res.data.data.list] : [...this.list, ...res.data.data.list]
                    } else {
                        // condition 不为空 且 list为空
                        if (this.condition) {
                            this.isEmpty = true
                        } else {
                            this.isFirst = true
                        }
                    }
                    if(!mescroll) return
                    this.$nextTick(() => {
                      mescroll.endSuccess(data.list.length)
                    })
                }
                // $CA.util.NativeAPI.invoke('hiddenCloseBtn',{"hiddenClose":"1"})

            }).catch((error) => {
                removeClass2('body', 'loading')
                Toast.fail(error.response.data.message)
                this.pullLoading = false
                console.error(error)
            })

        },
        deleteItem(item) {
            for (let index = 0; index < this.list.length; index++) {
                const element = this.list[index]
                if (item == element.pageId) {
                    this.list.splice(index, 1)
                }
            }
        },
        onRefresh() {
            this.finished = false
            // 将 pullLoading 设置为 true，表示处于加载状态
            this.pullLoading = true
            // 清空数据
            this.refreshing = true
            this.sheetShow = false
            this.pageNum = 1
            this.getList()
        },
        // 面板操作
        openSheet(item) {
            this.curItem = item
            this.sheetShow = true
        },
        //
        onSearch() {
            this.refreshing = true
            this.mescroll.resetUpScroll(true)
            // this.getList()
        },
        onCreate() {
            this.createSheetShow = true
        },
        onCancel() {
            this.sheetShow = false
        },
        cancelSearch() {
            this.createBtnShow = true
            this.onSearch()
        },
        onFocus() {
            this.createBtnShow = false
        },
        // onBlur() {
        //     this.createBtnShow = true
        // },
        onClear() {},
        onInput() {
            this.createBtnShow = false
        },
    },
}
</script>
<style lang="scss" scoped>
.wrap{
  height: 100%;
//   overflow: scroll;
  .form-search{
    position: fixed;
    z-index: 1;
    width: 100%;
  }
  .mescroll{
    position: fixed;
    top: 1.4rem;
    bottom: 0;
    height: initial;
    &.guagua{
      top: 2.6rem;
    }
  }
  .create-btn{
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #06B455;
    border-radius: 6px;
  }
  .me-pull-refresh{
    min-height: calc(100vh - 100px);
  }
  .me-list{
    width: 100%;
    height: 100%;
  }
  .card{
    display: flex;
    margin: 15px 10px;
    // height: 80px;
    background: white;
    border-radius: 10px;
    box-sizing: content-box;
    padding: 15px;
    color: #9298A8;
    .main{
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .title{
        font-size: 14px;
        font-weight: bold;
        color: #333;
        width: 100%;
        line-height: 22px;
        overflow : hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
      .content{
        p{
          margin: 0;
          margin-top: 14px;
        }
        .Published,
        .Unpublished {
          width: 50px;
          height: 24px;
          line-height: 24px;
          border-radius: 4px;
          text-align: center;
          font-size: 12px;
          color: #06B455;
          background-color: #D7FFCF;
        }
        .Unpublished{
          color: #F74D4D;
          background-color: #FFECEC;
        }
      }
    }
    .right{
      border-left: 1px solid #F2F4F6;
      padding-left: 15px;
      width: 100px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      .title{
        text-align: center;
        font-size: 13px;
        color: #9298A8;
        .Published,
        .Unpublished {
          font-size: 20px;
          color: #06B455;
        }
        .Unpublished{
          color: #5F6670;
        }
      }
      .content{
        margin-top: 8px;
        text-align: center;
      }
    }

  }

  .empty-content{
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
    font-size: 14px;
    font-weight: bold;
    color: #333;
    width: 216px;
    height: 212px;
    text-align: center;
    img{
      width:100%;
    }
    .sub {
        font-size: 12px;
        font-weight: normal;
        color: #9298A8;
    }
  }
}

</style>

